import { CSSProperties } from "react";
import { Toaster } from "sonner";

export function Notifications() {
  return (
    <Toaster
      position="top-center"
      duration={3000}
      offset={0}
      style={{ "--mobile-offset": "0px", top: "0px" } as CSSProperties}
    />
  );
}
